
























































import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import UploadImage from "@/shared/components/UploadImage/Index.vue";
import TinyMceEditor from "@/shared/components/TinymceEditor/index.vue";
import {FormModel} from "ant-design-vue";
import {ContactStore} from "@/modules/contact/store";
import {assignValueToForm} from "@/shared/services/helper/utils";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";

const form = {
  id: "",
  phoneNumber: "",
  provinceId: "",
  districtId: "",
  note: "",
  postOfficeRowGuid: undefined,
  partnerRowGuid: undefined,
  status: CommonStatus.Active
}
@Component({
    name: "ArticleForm",
    components: {PartnerSelector, DistrictSelector, ProvinceSelector, AInputCustom, EnumSelector, PostOfficeSelector, TinyMceEditor, UploadImage}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly id!: number;

    CommonStatus = CommonStatus;
    form = { ...form };
    rules = {
      phoneNumber: [{ required: true, message: "Nhập số điện thoại", trigger: "change" }],
      note: [{ required: true, message: "Nhập ghi chú", trigger: "change" }],
      provinceId: [{ required: true, message: "Nhập tỉnh/thành phố", trigger: "change" }],
      districtId: [{ required: true, message: "Nhập phường/xã", trigger: "change" }],
      postOfficeRowGuid: [{ required: true, message: "Nhập bưu cục phát", trigger: "change" }],
      partnerRowGuid: [{ required: true, message: "Nhập đối tác phát", trigger: "change" }]
    }

    async created() {
        if (this.id) {
            try {
                const data = await ContactStore.singleContact(this.id);
                data.provinceId = data.province.id;
                data.districtId = data.district.id;
                data.partnerRowGuid = data.partner.rowGuid;
                data.postOfficeRowGuid = data.postOffice.rowGuid;
                data.status = CommonStatus.Active; // re active
                this.form = assignValueToForm(this.form, data);
                console.log(this.form);
            } catch (e) {
                this.$message.error({
                    content: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
                })
            }
        }
    }

    onSubmit() {
        (this.$refs.formContact as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                this.id
                    ? await ContactStore.editContact(this.form)
                    : await ContactStore.createContact(this.form);
                this.$notification.success({
                    message: "Thành công",
                    description: `${this.id ? 'Sửa' : 'Tạo'} danh bạ thành công`
                });
                this.$router.push({name: "contactList"});
            } catch (e) {
                this.$message.error(`${e.response?.data?.message || `${this.id ? 'Sửa' : 'Tạo'} danh bạ thất bại`}`)
            }
        })
    }
}
